import { useMutation, useQueryClient } from '@tanstack/react-query';
import { promoteLead } from '@/api/promote';
import type { PromoteAccountRequest } from '@/types/promote';

export function usePromoteLead(leadId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: PromoteAccountRequest) => promoteLead(leadId, body),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['crm', 'lead', leadId] }),
        queryClient.invalidateQueries({ queryKey: ['crm', 'leads'] }),
        queryClient.invalidateQueries({ queryKey: ['crm', 'accounts'] }),
        queryClient.invalidateQueries({ queryKey: ['crm', 'dashboard'] }),
      ]);
    },
  });
}
